import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { ButtonComponent } from '../generic-button/button.component';

export type DialogActionVariant =
  | 'primary'
  | 'secondary'
  | 'secondary-no-border';

export interface DialogShellAction {
  readonly id: string;
  readonly label: string;
  readonly variant?: DialogActionVariant;
  readonly color?: string;
  readonly disabled?: boolean;
  readonly loading?: boolean;
  readonly disabledBgColor?: string;
  readonly disabledTextColor?: string;
  readonly hidden?: boolean;
}

@Component({
  selector: 'lib-dialog-shell',
  standalone: true,
  imports: [NgClass, ButtonComponent],
  templateUrl: './dialog-shell.component.html',
  styleUrl: './dialog-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogShellComponent {
  readonly title = input.required<string>();

  readonly closeAriaLabel = input('Close');
  readonly showCloseButton = input(true);
  readonly showFooter = input(true);

  readonly actions = input<readonly DialogShellAction[]>([]);

  readonly closeClicked = output<void>();
  readonly actionClicked = output<DialogShellAction>();

  private readonly isVisibleAction = (action: DialogShellAction): boolean =>
    !action.hidden;

  protected readonly visibleActions = computed<readonly DialogShellAction[]>(
    () => this.actions().filter(this.isVisibleAction)
  );

  protected onActionClick(action: DialogShellAction): void {
    if (action.disabled === true || action.loading === true) {
      return;
    }

    this.actionClicked.emit(action);
  }

  protected readonly trackAction = (
    _: number,
    action: DialogShellAction
  ): string => action.id;
}
